exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkout--footer .contact-info h3 {\n  color: currentColor;\n}\r\n", ""]);

// exports
